// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as ProfileAvatarContext$LiteracyplanetClientSxEntry from "./ProfileAvatarContext.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["query GetSelectionOfAvatarIds($userId: String!)  {\ncurrentStudent(userId: $userId)  {\n__typename  \nenrollee  {\n__typename  \nselectionOfUserIds  \n}\n\n}\n\nrecentAvatarUserIds  \n}\n"]);

function parse(value) {
  var value$1 = value.currentStudent;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.enrollee;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.selectionOfUserIds;
      tmp$1 = {
        __typename: value$2.__typename,
        selectionOfUserIds: value$3.map(function (value) {
              return value;
            })
      };
    }
    tmp = {
      __typename: value$1.__typename,
      enrollee: tmp$1
    };
  }
  var value$4 = value.recentAvatarUserIds;
  return {
          currentStudent: tmp,
          recentAvatarUserIds: value$4.map(function (value) {
                return value;
              })
        };
}

function serialize(value) {
  var value$1 = value.recentAvatarUserIds;
  var recentAvatarUserIds = value$1.map(function (value) {
        return value;
      });
  var value$2 = value.currentStudent;
  var currentStudent;
  if (value$2 !== undefined) {
    var value$3 = value$2.enrollee;
    var enrollee;
    if (value$3 !== undefined) {
      var value$4 = value$3.selectionOfUserIds;
      var selectionOfUserIds = value$4.map(function (value) {
            return value;
          });
      var value$5 = value$3.__typename;
      enrollee = {
        __typename: value$5,
        selectionOfUserIds: selectionOfUserIds
      };
    } else {
      enrollee = null;
    }
    var value$6 = value$2.__typename;
    currentStudent = {
      __typename: value$6,
      enrollee: enrollee
    };
  } else {
    currentStudent = null;
  }
  return {
          currentStudent: currentStudent,
          recentAvatarUserIds: recentAvatarUserIds
        };
}

function serializeVariables(inp) {
  return {
          userId: inp.userId
        };
}

function makeVariables(userId, param) {
  return {
          userId: userId
        };
}

var GetSelectionOfAvatarIds_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var GetSelectionOfAvatarIds = {
  GetSelectionOfAvatarIds_inner: GetSelectionOfAvatarIds_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

var Q = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

var emptyAvatars = [];

var avatars = {
  contents: /* [] */0
};

async function popOr(num, notEnough) {
  var match = Belt_List.splitAt(avatars.contents, num);
  if (match !== undefined) {
    avatars.contents = match[1];
    return Belt_List.toArray(match[0]);
  } else {
    return await Curry._1(notEnough, undefined);
  }
}

function appendToAvatars(selectionOfUserIds) {
  avatars.contents = Belt_List.concat(avatars.contents, Belt_List.fromArray(selectionOfUserIds));
}

function ProfileRecentAvatarProvider(props) {
  var fetchAvatarIds = Curry._1(Q.useAsync, undefined);
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var f = async function (num) {
    if (Curry._1(hasFlag, "FeatDynamicAvatarIds")) {
      return await popOr(num, (async function (param) {
                    var res = await Curry._1(fetchAvatarIds, {
                          userId: userId
                        });
                    if (res === undefined) {
                      return emptyAvatars;
                    }
                    var match = res.currentStudent;
                    if (match === undefined) {
                      return emptyAvatars;
                    }
                    var match$1 = match.enrollee;
                    if (match$1 !== undefined) {
                      appendToAvatars(Belt_Array.reduce(Belt_Array.concatMany([
                                    res.recentAvatarUserIds.filter(function (id) {
                                          return id !== userId;
                                        }),
                                    match$1.selectionOfUserIds
                                  ]), [], (function (acc, curr) {
                                  if (Belt_Array.some(acc, (function (id) {
                                            return id === curr;
                                          }))) {
                                    return acc;
                                  } else {
                                    return Belt_Array.concatMany([
                                                acc,
                                                [curr]
                                              ]);
                                  }
                                })));
                      return await popOr(num, (async function (param) {
                                    return emptyAvatars;
                                  }));
                    } else {
                      return emptyAvatars;
                    }
                  }));
    } else {
      return emptyAvatars;
    }
  };
  return React.createElement(ProfileAvatarContext$LiteracyplanetClientSxEntry.Provider.make, {
              value: f,
              children: props.children
            });
}

var make = ProfileRecentAvatarProvider;

export {
  GetSelectionOfAvatarIds ,
  Q ,
  emptyAvatars ,
  avatars ,
  popOr ,
  appendToAvatars ,
  make ,
}
/* query Not a pure module */
